var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 17,
    viewBox: "0 0 8 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96434 16.748H5.18528V8.68071H7.43395L7.67328 5.97832H5.18528V4.43766C5.18528 3.79946 5.31492 3.55016 5.92819 3.55016H7.67328V0.748047H5.44455C3.0463 0.748047 1.96434 1.80507 1.96434 3.82439V5.97832H0.289062V8.71561H1.96434V16.748Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.0a151e17a1b3ff0f367bb2803b63c591.svg";
export { ForwardRef as ReactComponent };